import React from 'react';

export function usePoseWithBulma(isActive) {
  const [finishedAnimation, setFinishedAnimation] = React.useState(true);

  const currentPose = React.useMemo(() => (isActive ? 'visible' : 'hidden'), [
    isActive,
  ]);
  const isVisible = React.useMemo(() => isActive || !finishedAnimation, [
    isActive,
    finishedAnimation,
  ]);

  if (isActive && finishedAnimation) {
    setFinishedAnimation(false);
  }

  const onPoseComplete = React.useCallback(() => {
    if (!isActive) {
      setFinishedAnimation(true);
    }
  }, [isActive, setFinishedAnimation]);

  return [currentPose, isVisible, onPoseComplete];
}
